import React, { useEffect, useState } from 'react';
import BaseModal from '../../../../components/modals/BaseModal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { useOrganizationContext } from '../../../../context/organization_context/OrganizationContext';
import { updateUnitOfMeasure } from '../../../../repository/UOMDAO';
import { useToast, ToastType } from '../../../../context/toast/ToastContext';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { Typography } from '@mui/material';

const EditUOMModal = ({ show, onHide, uom }) => {
    const [capacity, setCapacity] = useState("");
    const [capacityError, setCapacityError] = useState(false);
    const { setLoadingData } = useLoadingContext();
    const { organization } = useOrganizationContext();
    const { showToast } = useToast();
    const { t } = useTranslation();

    useEffect(() => {
        if (uom) {
            setCapacity(uom.capacity);
        }
    }, [uom, show]);

    const handleSubmit = async () => {
        let valid = true;
    
        if (capacity === "" || isNaN(capacity) || capacity < 0) {
            setCapacityError(true);
            valid = false;
        }
    
        if (!valid) return;
    
        setLoadingData(true);
    
        try {
            const result = await updateUnitOfMeasure(organization.id, { 
                id: uom.id,
                capacity: capacity
            });
    
            if (result.success) {
                showToast(t(StringKeys.SUCCESSFULLY_UPDATED_X, {x: uom.id}), ToastType.SUCCESS);
                onHide();
            } else {
                showToast(t(StringKeys.FAILED_TO_UPDATE_X, {x: uom.id}), ToastType.DANGER);
            }
        } catch (error) {
            showToast(t(StringKeys.FAILED_TO_UPDATE_X, {x: uom.id}), ToastType.DANGER);
        } finally {
            setLoadingData(false);
        }
    };    

    const resetForm = () => {
        if (uom) {
            setCapacity(uom.capacity);
        }
        setCapacityError(false);
    };

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            maxWidth='sm'
            title={t(StringKeys.EDIT_UNIT_OF_MEASURE)}
            actions={
                <>
                    <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
                </>
            }
        >
            <Typography variant="subtitle1" gutterBottom>
                {uom?.id}
            </Typography>
            <TextField
                margin="dense"
                label={t(StringKeys.CAPACITY)}
                type="number"
                fullWidth
                variant="outlined"
                value={capacity}
                onChange={(e) => {
                    setCapacity(e.target.value);
                    if (capacityError) setCapacityError(false);
                }}
                error={capacityError}
                helperText={capacityError ? t(StringKeys.CAPACITY_MUST_BE_A_NON_NEGATIVE_INTEGER) : ""}
                InputProps={{ inputProps: { min: 0 } }}
            />
        </BaseModal>
    );
};

export default EditUOMModal;
